import React, { useMemo, useState } from "react";
import {
  Box,
  Button,
  Card,
  CircularProgress,
  Dialog,
  Grid,
  Typography,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import {
  useGetEmployeeImgQuery,
  useGetPrinterQuery,
} from "../../../Api/attoDeskApi";
import { useStyles } from "../../../theme/appStyles";
import Avatar from "@mui/material/Avatar";
import ImageIcon from "@mui/icons-material/Image";
import AvatarImg from "../../../Images/avatar.png";
import useIsMobile from "../../../Core/hook/useIsMobile";

interface IDepartmentPopUp {
  openModel?: boolean;
  handleCloseDialog: (close: boolean) => void;
  imgId?: string;
}

const Department = ({
  openModel = false,
  handleCloseDialog,
  imgId,
}: IDepartmentPopUp) => {
  const classes = useStyles();
  const isMobileRes = useIsMobile();
  const [open] = React.useState(openModel);
  const theme = useTheme();
  const [openPrinter, setOpenPrinter] = useState(false);
  const { data: printerData, isLoading: printerLoading } = useGetPrinterQuery({
    searchText: "",
  });

  const { data, isLoading, isError, refetch } = useGetEmployeeImgQuery({
    id: imgId || "", // imgId passed or empty string
  });

  // Conditional rendering based on data response
  const employeeImage = data?.data?.emp_image;

  const printerList = useMemo(() => {
    return printerData?.data || [];
  }, [printerData?.data]);

  const handleClose = () => {
    handleCloseDialog(false);
  };

  // if (isLoading)
  // return (
  //   <Box
  //     display="flex"
  //     justifyContent="center"
  //     alignItems="center"
  //     height="10vh"
  //   >
  //     <CircularProgress />
  //   </Box>
  // );

  return (
    <Dialog
      open={open}
      onClose={handleClose}
      aria-describedby="alert-dialog-description"
      classes={{ paper: "inherit" }}
      fullScreen={isMobileRes}
      fullWidth={isMobileRes}
      maxWidth="lg"
    >
      <Grid className={isMobileRes ? classes.DialogMobile :classes.Dialog}>
        <Grid container spacing={3}>
          <Grid item lg={12} md={12} sm={12} xs={12}>
            <Card className={classes.stepperCard}>
              <Grid
                container
                justifyContent={"space-between"}
                spacing={5}
                sx={{ borderBottom: 2, padding: 2 }}
                className={classes.titleGrid}
              >
                <Grid
                  item
                  lg={12}
                  md={12}
                  sm={12}
                  xs={12}
                  pt={2}
                  alignContent={"center"}
                >
                  <Typography className={classes.cardTitle}>
                    Employee Image
                  </Typography>
                </Grid>
              </Grid>
            </Card>
          </Grid>

          <Grid item lg={12} md={12} sm={12} xs={12}>
            <Grid container>
              <Grid item lg={12} md={12} sm={12} xs={12}>
                <Card className={classes.card}>
                  {isLoading ? (
                    <Grid
                      item
                      container
                      justifyContent="center"
                      alignItems="center"
                      padding={5}
                    >
                      <Box
                        display="flex"
                        justifyContent="center"
                        alignItems="center"
                        height="10vh"
                        sx={{
                          width: "300px",
                          height: "300px",
                        }}
                      >
                        <CircularProgress />
                      </Box>
                    </Grid>
                  ) : (
                    <Grid
                      item
                      container
                      justifyContent="center"
                      alignItems="center"
                      padding={5}
                    >
                      {employeeImage ? (
                        <img
                          src={`data:image/png;base64,${employeeImage}`}
                          alt="Employee Image"
                          style={{
                            width: "300px", // Set the width to make the image bigger
                            height: "300px", // Set the height for the image
                            objectFit: "cover", // Ensure the image covers the area without distorting
                            borderRadius: "8px", // Optional, makes the image round (like an avatar)
                          }}
                        />
                      ) : (
                        <Avatar
                          alt="Travis Howard"
                          src={AvatarImg}
                          sx={{
                            bgcolor: "gray",
                            width: 120, // Set the width of the Avatar (make it bigger)
                            height: 120, // Set the height of the Avatar
                            fontSize: "48px", // Increase font size of the icon inside the Avatar
                          }}
                        >
                          <ImageIcon sx={{ fontSize: "48px" }} />{" "}
                          {/* Adjust the icon size */}
                        </Avatar>
                      )}
                    </Grid>
                  )}
                </Card>
              </Grid>

              <Grid item lg={12} md={12} sm={12} xs={12} pt={3}>
                <Card className={classes.card}>
                  <Grid container spacing={3} p={"24px"}>
                    <Grid
                      item
                      lg={12}
                      md={12}
                      sm={12}
                      xs={12}
                      sx={{ display: "flex", justifyContent: "flex-end" }}
                    >
                      <Button
                        variant="outlined"
                        startIcon={<CloseIcon />}
                        className={classes.addButton}
                        onClick={handleClose}
                      >
                        Cancel
                      </Button>
                      <Box m={0.5}></Box>
                    </Grid>
                  </Grid>
                </Card>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </Dialog>
  );
};

export default Department;
